module.exports = __webpack_public_path__ + "static/media/memento.342eb3fe.png";